import { gql } from '@apollo/client';

export const REQUEST_ASSISTANCE = gql`
  mutation RequestAssistance (
      $name: String!
      $email: String!
      $phone: String!
      $tailNumber: String
      $issue: String
    )
  {
    requestAssistance(
      name: $name
      email: $email
      phone: $phone
      tailNumber: $tailNumber
      issue: $issue
    ) {
      errors {
        message
        path
      }
    }
  }
`;